export default "__VITE_ASSET__CKbpocwZ__"